import { z } from "zod";

const RevenueMonthlyDataResponse = z.object({
    month: z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Invalid date format (YYYY-MM-DD)"),
    rates: z.number().nonnegative("Rates must be a non-negative number"),
});

const RevenueMonthlyResponseSchema = z.object({
    success: z.boolean(),
    message: z.string().min(1, "Message cannot be empty"),
    code: z.number().int().nonnegative("Code must be a non-negative integer"),
    data: z.array(RevenueMonthlyDataResponse),
});

export type RevenueMonthlyDataResponse = z.infer<typeof RevenueMonthlyDataResponse>;
export type RevenueMonthlyResponse = z.infer<typeof RevenueMonthlyResponseSchema>;
export { RevenueMonthlyDataResponse, RevenueMonthlyResponseSchema };